import { ErrorObject } from '@app/_shared/interfaces';
import { createAction, props } from '@ngrx/store';

const actionPrefix = '[Dashboard]';

export const loadDashboardStatistics = createAction(`${actionPrefix} Load Dashboard Statistics`);
export const loadInitialDashboardStatistics = createAction(`${actionPrefix} Load Initial Dashboard Statistics`);

export const loadDashboardStatisticsSuccess = createAction(
  `${actionPrefix} Load Dashboard Statistics Success`,
  props<{ data: { bookkeepingJobsCount: number; ordersCount: number; apiIntegrationsCount: number } }>(),
);

export const loadDashboardStatisticsFailure = createAction(
  `${actionPrefix} Load Dashboard Statistics Failure`,
  props<{ error: ErrorObject }>(),
);
